// @flow
import React, { Component } from 'react';
import { Button, Glyphicon, Grid, DropdownButton, MenuItem, Tabs, Tab, Row, Col, FormGroup, ControlLabel, FormControl, Table, Label, ListGroup, ListGroupItem, ProgressBar } from 'react-bootstrap';
import firebase from 'firebase';
import Loading from '../../components/Loading';
import { Line } from 'react-chartjs';
import { LANG } from '../../config';
import _ from 'lodash';

type IProps = {
  users: Array<Object>,
  lessons: Array<Object>,
  room: string,
  section: Object,
}

type IState = {
  lessonIndex: number,
  data: Object,
  dataUsers: Object,
  loading: boolean,
  sort: {
    key: string,
    asc: boolean,
  },
}

class Activity extends Component {  

  constructor(props: IProps) {
    super(props);

    this.state = {
      lessonIndex: -1,
      data: {},
      dataUsers: {},
      loading: true,
      sort: {
        key: 'original',
        asc: true,
      },
    };
  }

  state: IState;

  componentDidMount() {
    this.reload();
  }

  componentDidUpdate(prevProps: IProps, prevState: IState) {
    if (this.props.section.id !== prevProps.section.id) {
      this.reload();
    }
  }
  
  reload() {
    this.setState(
      {
        loading: true,
      },
      () => {
        const { room, section } = this.props;

        const object = {};
        const dataUsers = {};
      
        firebase.database()
        .ref(`room/${room}/${section.statistics}`)
        .on('value', (snapshot2) => {
          const statictics = snapshot2.val() || {};
          
          Object.keys(statictics).map((key) => {
            const item = statictics[key];
            if (item.language === LANG.ORIGINAL) {
              const date = new Date(item.date);
              const user = item.user;

              const year = date.getFullYear();
              const month = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
              const dayInMonth = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

              const day = `${year}/${month}/${dayInMonth}`;

              if (object[day]) {
                object[day] = object[day] + 1;
              } else {
                object[day] = 1;
              }

              if (dataUsers[day]) {
                if (dataUsers[day][user]) {
                  dataUsers[day][user] = dataUsers[day][user] + 1;
                } else {
                  dataUsers[day][user] = 1;
                }
              } else {
                dataUsers[day] = {
                  [user]: 1,
                };
              }
            }
          });

          this.setState({
            data: object,
            dataUsers,
            loading: false,
          });
        });
      },
    );
  }

  handleChangeTab(lessonIndex: string) {
    this.setState({
      lessonIndex,
    });
  }

  handleDropdownEvent(item, allAnswers, event) {
    const { room, section } = this.props;

    if (event === 'accept') {
      allAnswers.forEach((answer) => {
        const answers = [].concat(item[LANG.OTHER]);
        answers.push(answer.value);

        console.log(room, section.id, item.key, item.en, answers);

        const updates = {
          [`room/${room}/${section.id}/${item.key}/${LANG.OTHER}`]: _.uniq(answers),
          [`room/${room}/${section.statistics}/${answer.key}/accepted`]: true,
        };
        firebase.database().ref().update(updates);
      });
    }

    if (event === 'delete') {
      allAnswers.forEach((answer) => {
        const updates = {
          [`room/${room}/${section.statistics}/${answer.key}/deleted`]: true,
        };
        firebase.database().ref().update(updates);
      });
    }
  }
  
  props: IProps;

  render() {
    if (this.state.loading) return <Loading />;

    const { users, lessons } = this.props;
    const { data, dataUsers, lessonIndex, sort } = this.state;


    const chartData = {
      labels: Object.keys(data).map((label, index) => (index - 1) % 3 === 0 ? label : label),
      datasets: [
        {
          label: "My First dataset",
          fillColor: "rgba(220,220,220,0.2)",
          strokeColor: "rgba(14, 178, 255,1)",
          pointColor: "rgba(14, 178, 255,1)",
          pointStrokeColor: "#fff",
          pointHighlightFill: "#fff",
          pointHighlightStroke: "rgba(14, 178, 255,1)",
          data: Object.keys(data).map(key => data[key]),
        },
      ]
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: "Chart.js Combo Bar Line Chart"
        },
    };

    let dates = [];

    let start = new Date(Object.keys(data).sort((a,  b) => (a < b) ? -1 : 1)[0]);
    let end = new Date(Object.keys(data).sort((a,  b) => (a > b) ? -1 : 1)[0]);
    const newend = end.setDate(end.getDate()+1);
    end = new Date(newend);
    while(start < end){

      const year = start.getFullYear();
      const month = start.getMonth() < 9 ? `0${start.getMonth() + 1}` : start.getMonth() + 1;
      const dayInMonth = start.getDate() < 10 ? `0${start.getDate()}` : start.getDate();

      const day = `${year}/${month}/${dayInMonth}`;
      dates.push(day);


      const newDate = start.setDate(start.getDate() + 1);
      start = new Date(newDate);
    }


    return (
      <div>
        <Row>
          <Col xs={12} style={{ height: '500px' }}>
            <Line data={chartData} options={chartOptions} />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
          <Table striped bordered condensed hover style={{ marginTop: '50px' }}>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Number of items</th>
                  <th>Active users per day</th>
                  <th>Average items per user</th>
                </tr>
              </thead>
              <tbody>
                {
                  dates.map((key, index) => (
                    <tr>
                      <td>{key}</td>
                      <td>{data[key] || 0}</td>
                      <td>{Object.keys(dataUsers[key] || {}).length || 0}</td>
                      <td>{parseInt((data[key] > 0 && Object.keys(dataUsers[key] || {}).length > 0) ? data[key] / Object.keys(dataUsers[key] || {}).length : 0)}</td>
                    </tr>
                  ))
                }
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Activity;

/*
            <Table striped bordered condensed hover>
              <thead>
                <tr>
                  <th style={{ textAlign: 'center', fontSize: '18px' }}>Items</th>
                  <th style={{ textAlign: 'center', fontSize: '18px' }}>Answers</th>
                  <th style={{ textAlign: 'center', fontSize: '18px' }}>Correct answers</th>
                  <th style={{ textAlign: 'center', fontSize: '18px' }}>Incorrect answers</th>
                  <th style={{ textAlign: 'center', fontSize: '18px' }}>Percentage</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ textAlign: 'center', fontSize: '30px' }}>
                  <td><Label bsStyle="info">{items.length}</Label></td>
                  <td><Label bsStyle="default">{total}x</Label></td>
                  <td><Label bsStyle="success">{correct}x</Label></td>
                  <td><Label bsStyle="danger">{total - correct}x</Label></td>
                  <td><Label bsStyle={style}>{percentage}%</Label></td>
                </tr>
              </tbody>
            </Table>
            <Table striped bordered condensed hover>
              <thead>
                <tr>
                  <th></th>
                  <th><Button bsStyle="link" block onClick={() => { this.setState({ sort: { key: 'total', asc: !sort.asc } }); } }><Glyphicon glyph="sort" /> Answers</Button></th>
                  <th><Button bsStyle="link" block onClick={() => { this.setState({ sort: { key: 'valid', asc: !sort.asc } }); } }><Glyphicon glyph="sort" /> Correct</Button></th>
                  <th><Button bsStyle="link" block onClick={() => { this.setState({ sort: { key: 'invalid', asc: !sort.asc } }); } }><Glyphicon glyph="sort" /> Incorrect</Button></th>
                  <th><Button bsStyle="link" block onClick={() => { this.setState({ sort: { key: 'percentage', asc: !sort.asc } }); } }><Glyphicon glyph="sort" /> Percentage</Button></th>
                </tr>
              </thead>
              <tbody>
                {
                  items.map(item => ( { original: item.original, total: item.total || 0, valid: item.valid, invalid: item.total - item.valid, percentage: item.total > 0 ? parseInt((item.valid / item.total) * 100) : 0 } )).sort((a, b) => { return sort.asc ? a[sort.key] - b[sort.key] : b[sort.key] - a[sort.key] }).map((item) => {
                    return (
                      <tr>
                        <td>{item.original}</td>
                        <td style={{ textAlign: 'center' }}>{item.total}</td>
                        <td style={{ textAlign: 'center' }}>{item.valid}</td>
                        <td style={{ textAlign: 'center' }}>{item.invalid}</td>
                        <td style={{ textAlign: 'center' }}><span>{item.percentage}%</span></td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </Table>*/


// WEBPACK FOOTER //
// ./src/pages/Statistics/Activity.js